// Дальность соблазнения (гекс-дистанция, без учёта препятствий/линии видимости)
export const SUCCUBES_SEDUCTION_RANGE = 3;

// Минимальный итог (d20 + разница численности), при котором соблазнение удаётся
export const SUCCUBES_SEDUCTION_SUCCESS_THRESHOLD = 14;

// Стоимость одной попытки соблазнения в монетах - списывается независимо от исхода
export const SUCCUBES_SEDUCTION_COST = 2;

// Цвет итогового результата попытки на поле - фирменный фиолетовый фракции
// (тот же textColor, что в FACTION_CONFIGS), чтобы не путать с цветом урона
export const SUCCUBES_SEDUCTION_RESULT_COLOR = '#9d46cb';
